/* Hero Carousel — Infinite carousel, swipe, video management */
(function() {
  'use strict';

  var carousel = document.querySelector('[data-hero-carousel]');
  if (!carousel) return;

  var track = carousel.querySelector('[data-hero-track]');
  var slides = track.querySelectorAll('.hero-carousel__slide');
  var prevBtn = carousel.querySelector('[data-hero-prev]');
  var nextBtn = carousel.querySelector('[data-hero-next]');
  var progressBars = carousel.querySelectorAll('[data-progress-index]');
  var total = slides.length;
  var current = 0;
  var isMobile = window.innerWidth < 768;
  var autoTimer = null;

  if (total === 0) return;

  /* Mobile starts at image slide (index 1 if exists) */
  if (isMobile && total > 1) {
    current = 1;
  }

  function goTo(index) {
    current = ((index % total) + total) % total;

    if (isMobile) {
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }
    /* On desktop all 3 are visible side by side — no translate needed */

    /* Manage videos */
    slides.forEach(function(slide, i) {
      var video = slide.querySelector('video');
      if (!video) return;

      if (isMobile) {
        if (i === current) {
          video.currentTime = 0;
          video.play().catch(function() {});
        } else {
          video.pause();
        }
      } else {
        /* Desktop: play all visible videos */
        video.play().catch(function() {});
      }
    });

    /* Update progress bars (mobile) */
    updateProgress();
  }

  function updateProgress() {
    progressBars.forEach(function(bar, i) {
      var fill = bar.querySelector('.hero-carousel__progress-fill');
      bar.classList.toggle('is-active', i === current);
      if (fill) {
        if (i === current) {
          var duration = parseInt(slides[i].dataset.slideDuration) || 5000;
          fill.style.transition = 'none';
          fill.style.width = '0%';
          /* Force reflow */
          fill.offsetHeight;
          fill.style.transition = 'width ' + duration + 'ms linear';
          fill.style.width = '100%';
        } else {
          fill.style.transition = 'none';
          fill.style.width = '0%';
        }
      }
    });
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startAuto() {
    stopAuto();
    if (!isMobile) return;

    var duration = parseInt(slides[current].dataset.slideDuration) || 5000;
    autoTimer = setTimeout(function() {
      next();
      startAuto();
    }, duration);
  }

  function stopAuto() {
    clearTimeout(autoTimer);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startAuto(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { next(); startAuto(); });

  /* Touch swipe (mobile) */
  var startX = 0;
  var startY = 0;
  var isDragging = false;

  track.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
  }, { passive: true });

  track.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    var diffX = startX - e.changedTouches[0].clientX;
    var diffY = startY - e.changedTouches[0].clientY;

    /* Only navigate if horizontal swipe dominates */
    if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX > 0) next();
      else prev();
      startAuto();
    }
  });

  /* Progress bar clicks */
  progressBars.forEach(function(bar) {
    bar.addEventListener('click', function() {
      goTo(parseInt(bar.dataset.progressIndex));
      startAuto();
    });
  });

  /* Resize handler */
  window.addEventListener('resize', function() {
    var nowMobile = window.innerWidth < 768;
    if (nowMobile !== isMobile) {
      isMobile = nowMobile;
      goTo(isMobile ? 1 : 0);
      if (isMobile) startAuto();
      else stopAuto();
    }
  });

  /* Init */
  goTo(current);
  if (isMobile) startAuto();

  /* Desktop: auto-play all videos */
  if (!isMobile) {
    slides.forEach(function(slide) {
      var video = slide.querySelector('video');
      if (video) video.play().catch(function() {});
    });
  }
})();
